import { IoMdCloseCircleOutline } from "react-icons/io";
import "./Modal.css";
const Modal = ({ showModal, handleCloseClick, children }) => {
  return (
    showModal && (
      <div
        data-testid="spinnerContainer"
        id="loading-spinner"
        className="modal-container"
      >
        <div className="modal-content">
          <IoMdCloseCircleOutline
            className="close-icon"
            onClick={handleCloseClick}
          />
          {children}
        </div>
      </div>
    )
  );
};

export default Modal;
